import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ShiftState} from "@/modules/shift/state";
import {IdMapper} from "@/interfaces/state/base";
import {Shift} from "@/modules/shift/entity/shift";
import {PaginationMeta} from "@/interfaces/common";
import {ShiftEmployeeParams, ShiftParams} from "@/modules/shift/params";
import {ShiftEmployee} from "@/modules/shift/entity/shiftemployee";
import store from "@/store";
import union from "lodash/union";
import {
    addEmployeeToShift,
    createShift,
    deleteShift,
    editShift, listEmployeeShift,
    listShift, removeEmployeeFromShift,
    singleShift
} from "@/modules/shift/services";

@Module({ dynamic: true, name: 'shift', store })
class ShiftModule extends VuexModule implements ShiftState {
    data: IdMapper<Shift> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ShiftParams = new ShiftParams();
    
    dataEmployee: IdMapper<ShiftEmployee> = {};
    idsEmployee: number[] = [];
    metaEmployee: PaginationMeta = new PaginationMeta();
    paramsEmployee: ShiftEmployeeParams = new ShiftEmployeeParams();

    @Mutation
    private MAP_SHIFT(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas.map((shift: Shift) => {
            idMapper[shift.id] = shift;
            return shift.id;
        })
        this.data = idMapper;
    }

    @Mutation
    private MAP_SHIFT_EMPLOYEE(payload: any) {
        const idMapper = {} as any;
        this.metaEmployee = payload.meta;
        this.idsEmployee = payload.datas.map((shiftEmployee: ShiftEmployee) => {
            idMapper[shiftEmployee.id] = shiftEmployee;
            return shiftEmployee.id;
        })
        this.dataEmployee = idMapper;
    }

    @Mutation
    private SET_SHIFT(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data = { ...this.data, [payload.id]: payload };
    }

    @Mutation
    private REMOVE_SHIFT(payload: number) {
        this.ids = this.ids.filter((id: any) => id != payload);
    }

    @Mutation
    private SET_SHIFT_EMPLOYEE(payload: any) {
        this.idsEmployee = union(this.idsEmployee, [payload.id]);
        this.dataEmployee = { ...this.dataEmployee, [payload.id]: payload };
    }

    @Mutation
    private REMOVE_SHIFT_EMPLOYEE(payload: any) {
        this.idsEmployee = this.idsEmployee.filter((id: number) => id != payload)
    }

    @Mutation
    private UPDATE_PARAMS_SHIFT(payload: any) {
        this.params = payload;
    }

    @Mutation
    private UPDATE_PARAMS_SHIFT_EMPLOYEE(payload: any) {
        this.paramsEmployee = payload;
    }

    @Action({ rawError: true })
    public async createShift(payload: any) {
        const { data } = await createShift(payload);
        this.SET_SHIFT(data.data);
    }

    @Action({ rawError: true })
    public async editShift(payload: any) {
        const { data } = await editShift(payload);
        this.SET_SHIFT(data.data);
    }

    @Action({ rawError: true })
    public async singleShift(payload: any) {
        const { data } = await singleShift(payload);
        this.SET_SHIFT(data.data);
    }

    @Action({ rawError: true })
    public async deleteShift(payload: number) {
        const { data } = await deleteShift(payload);
        this.REMOVE_SHIFT(data?.data?.id);
    }

    @Action({ rawError: true })
    public async listShift(payload: any) {
        const { data } = await listShift(payload);
        this.MAP_SHIFT(data);
    }

    @Action({ rawError: true })
    public async listEmployeeInShift({ shiftId, params }) {
        const { data } = await listEmployeeShift(shiftId, params);
        this.MAP_SHIFT_EMPLOYEE(data);
    }

    @Action({ rawError: true })
    public async addEmployeeToShift(payload: any) {
        const { data } = await addEmployeeToShift(payload);
        this.SET_SHIFT_EMPLOYEE(data.data);
    }

    @Action({ rawError: true })
    public async removeEmployeeFromShift(payload: any) {
        const { data } = await removeEmployeeFromShift(payload);
        this.REMOVE_SHIFT_EMPLOYEE(data?.data?.id);
    }

    @Action({ rawError: true })
    public updateParamsShift(payload: any) {
        this.UPDATE_PARAMS_SHIFT(payload);
    }

    @Action({ rawError: true })
    public updateParamsShiftEmployee(payload: any) {
        this.UPDATE_PARAMS_SHIFT_EMPLOYEE(payload);
    }

}

export const ShiftStore = getModule(ShiftModule)